import React, { FC, useEffect, useState } from 'react';

import { Alert } from '@gravity-ui/uikit';
import i18n from '@yandex-int/i18n';
import * as keyset from 'i18n/GeneralSettings';
import queryString from 'query-string';

import { IndexLayout } from '../Layout/Layout';
import { PageLoader } from '../Loader/PageLoader';

import styles from './EmailPages.module.scss';

const t = i18n(keyset);

export const AuthRedirect: FC = () => {
    const [error, setError] = useState(false);

    useEffect(() => {
        try {
            const { status } = queryString.parse(location.search);
            window.opener.postMessage({ status }, window.location.origin);
        } catch (err) {
            console.error('@AuthRedirect', err);
            setError(true);
        }
    }, []);

    let content = <PageLoader />;
    if (error) {
        content = <Alert message={<div className={styles.emailPages__content}>{t('error')}</div>} theme="danger" />;
    }

    return (
        <IndexLayout hideSettings>
            <div className={styles.emailPages__container}>{content}</div>
        </IndexLayout>
    );
};
